export default __webpack_public_path__ + "static/media/work-card.d37649f5.png";